<template>
    <div class="additional-products-content"
         v-if="categories !== null && categories.length > 0"
    >
        <p class="header summary">Opcje dodatkowe</p>

        <div class="categories-list"
             v-for="category in categories"
        >
            <div class="tab-header-warp">
              <div class="tab-header"
                   @click="toggleItem(category.id)">
                  <img :src="category.image"
                       :alt="category.name"
                       width="40"
                       height="40"
                  />
                  <span class="title">
                      <strong>{{ category.name }}</strong>
                      <br>
                      {{ category.description }}
                  </span>
                  <span class="arrow-button"
                        :class="{ 'open': category.id === selectedCategory }"
                  ></span>
              </div>

              <template v-if="products !== null && products.length > 0">
                <div class="content"
                     v-for="product in products"
                     v-if="product.categoryId == category.id"
                     :class="{ 'open': category.id === selectedCategory }"
                >
                  <div class="add-image">
                    <img :src="product.image"
                         @click="showProduct(product)"
                         width="80"
                         height="80"
                         alt="Zobacz produkt"
                    />
                  </div>
                  <div class="add-name">
                    <div class="product-name-short">{{ product.name }}</div>
                    {{ product.price }}<br>
                    <br>
                    <a @click="showProduct(product)">Zobacz produkt</a>
                  </div>
                  <div class="add-button">
                    <button type="button"
                            @click="personalizeProduct(product)"
                            v-if="(symbolOpen !== product.symbol && product.isPersonalized)"
                            name="personalizuj"
                            value="Personalizuj"
                            class="button button-personalize-small"
                            title="Personalizuj"><span class="button-title">Personalizuj</span></button>
                    <button type="button"
                            @click="addProductToCart(product)"
                            v-if="(symbolOpen !== product.symbol && !product.isPersonalized)"
                            name="personalizuj"
                            value="Do koszyka"
                            class="button button-personalize-small"
                            title="Dodaj do koszyka"><span class="button-title">Do koszyka</span></button>
                    <button type="button"
                            @click="backToEdit()"
                            v-if="symbolOpen === product.symbol"
                            name="personalizuj"
                            value="Personalizuj"
                            class="button button-personalize-selected-small"
                            title="Powrót do edycji"><span class="button-title">Powrót do edycji</span></button>
                  </div>
                </div>
              </template>
            </div>
        </div>

        <sidebar-modal
          @close="toggleSidebarModal(false)"
          :class="{ 'visible': showSidebarModal }"
        >
          <div slot="header"
               v-if="product !== null"
          >
            <div class="modal-name">{{ product.name }}</div>
            <div class="modal-association-symbol small">{{ product.symbol }}</div>
            <a :href="product.url" class="modal-url small">Przejdź do produktu</a>
          </div>
          <div slot="body"
               v-if="product !== null"
          >

            <div class="swiper-container">
              <ul class="swiper-wrapper">
                <li class="swiper-slide">
                  <img :src="product.image" width="280" height="280" alt="Zdjęcie" />
                </li>
                <li class="swiper-slide">
                  <img :src="product.image2" width="280" height="280" alt="Zdjęcie" />
                </li>
              </ul>
              <br clear="all">
            </div><div class="tab-header">Szczegóły produktu</div>
            <div class="message" v-html="product.technicalDescription"></div>
          </div>
        </sidebar-modal>

    </div>
</template>

<script>
    import SidebarModal from "../../components/modal/SidebarModal";

    export default {
        name: "App",
        components: {
          SidebarModal
        },
        data() {
            return {
              selectedCategory: null,
              showSidebarModal: false,
              product: null,
              productSlider: null,
              symbolOpen: null
            }
        },
        computed: {
            categories() {
                return this.$store.getters['additionalProducts/categories']
            },
            products() {
                return this.$store.getters['additionalProducts/products']
            },
        },
        methods: {
          /**
           * @param {boolean} show
           * @param {String} elementName
           */
          toggleShowMore(show, elementName) {
            if (show) {
              document.querySelector("#"+elementName).classList.add("visible");
            } else {
              document.querySelector("#"+elementName).classList.remove("visible");
            }
            document.querySelector('body').style.overflowY = show ? 'hidden' : 'scroll';
          },

          /**
           * @param {String} action
           */
          toggleZenBox(action) {
            if (typeof zE == 'function') {
              if (window.zE.widget === 'messenger') {
                zE("messenger", action);
              } else {
                zE("webWidget", action);
              }
            }
          },

          backToEdit() {
            this.toggleShowMore(true, 'modal-personalization-inner');
            this.toggleZenBox("hide");
          },

          /**
           * @param {string} id
           */
          toggleItem(id) {
            if (this.selectedCategory === id.toString()) {
              this.selectedCategory = null;
            } else {
              this.selectedCategory = id.toString();
            }
          },

          /**
           * @param {Object} product
           */
          showProduct(product) {
            this.product = product;
            this.toggleSidebarModal(true);
          },

          /**
           * @param {Object} product
           */
          personalizeProduct(product) {
            window.location.href = 'koszyk.php?a=personalize&symbol=' + product.symbol;
          },

          /**
           * @param {Object} product
           */
          addProductToCart(product) {
            window.location.href = 'koszyk.php?a=add&pr=' + product.id + '&qty=1&return=999999';
          },

          /**
           * @param {boolean} status
           */
          toggleSidebarModal(status) {
            this.showSidebarModal = status;

            document.querySelector('body').style.overflowY = status ? 'hidden' : 'scroll';
            if (!status) this.product = null;
          },

          selectActiveProduct() {
            const url = new URL(window.location.href);
            const symbol = url.searchParams.get("symbol");
            if (symbol !== '') {
              this.symbolOpen = symbol;

              const product = this.products.find(product => product.symbol === symbol);
              if (product) {
                this.toggleItem(product.categoryId);
              }
            }
          }
        },
        async mounted() {
          try {
            await this.$store.dispatch('additionalProducts/fetchData');
          } catch (error) {
            toast.error("Wystąpił błąd podczas pobierania produktów dodatkowych")
          }

          this.selectActiveProduct();
        },
    }

</script>

<style lang="scss">
@import "../../../../scss/variables.scss";
@import "../../../../scss/mixins/breakpoint.scss";

    .additional-products-content {
        background-color: #eaf0ee;
        padding: 10px 20px 10px 20px;
        margin: 0 0 20px 0;
        border-radius: 12px;

        @include only-mobile-breakpoint() {
          padding: 10px 10px;
        }

        .sidebar-modal-wrapper-content {
            .swiper-container {
                overflow: auto;
                margin-bottom: 20px;

                .swiper-slide {
                    width: 280px;
                    height: auto;
                    margin-right: 20px;

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }

        header {
            margin: 10px 0 20px 0;

            font-size: 24px;
            font-family: 'Fraunces', sans-serif;

            &.summary {
                background-image: url("../../../../../assets/images/icons/icon-additional.svg");
                background-position: center left;
                background-repeat: no-repeat;
                padding-left: 40px;
            }

            .small {
                font-family: Helvetica, sans-serif;
                font-size: 16px;
            }

            a.small {
                font-family: Helvetica, sans-serif;
                font-size: 14px;
                text-decoration: underline;
                &:hover {
                    text-decoration: none;
                }
            }
        }

        .categories-list {
            display: block;
            padding: 0;
            margin: 0;
            position: relative;

            ul {
                list-style: disc;
                ul {
                    list-style: circle;
                }
                margin: 0 0 10px 10px;
                padding: 0 0 0 10px;
            }

            .tab-header-warp {
              border: 1px solid #AABCB6;
              border-radius: 8px;
              margin: 20px 0;
              padding: 10px;

              .tab-header {
                  color: #212121;
                  font-weight: 400;
                  font-size: 14px;
                  display: flex;
                  width: 100%;
                  cursor: pointer;
                  justify-content: space-between;
                  align-items: center;

                  img {
                      border-radius: 8px;
                  }

                  .title {
                      width: calc(100% - 90px);
                  }

                  .arrow-button {
                      background-size: contain;
                      width: 20px;
                      height: 20px;
                      margin: 0 0 0 10px;
                      display: inline-block;
                      background: url("../../../../images/icons/icon-circle-plus.svg") no-repeat center center;

                      &.open {
                          background: url("../../../../images/icons/icon-circle-minus.svg") no-repeat center center;
                      }

                      @include only-mobile-breakpoint() {
                          margin: 0 0 0 10px;
                      }
                  }
              }
            }

            .content {
                color: #373737;
                font-size: 14px;
                display: none;
                grid-template-rows: auto auto;
                gap: 0 0;
                padding: 20px 0 0 0;
                margin: 0;
                z-index: 1;
                position: relative;
                grid-template-columns: 90px auto 106px;
                grid-template-areas:
                    "add-image add-name add-button"
                    "add-image add-name add-button"
                ;

                @include breakpoint-1024() {
                  grid-template-columns: 90px auto;
                  grid-template-areas:
                    "add-image add-name"
                    "add-button add-button"
                  ;
                }

                &.open {
                  display: grid;
                }

                .add-image {
                  grid-area: add-image;
                  width: 90px;

                  img {
                    cursor: pointer;
                    border-radius: 8px;
                  }
                }
                .add-name {
                  grid-area: add-name;
                  font-size: 13px;

                  .product-name-short {
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    padding-top: 5px;
                    line-height: normal;
                  }

                  a {
                    text-decoration: underline;
                    cursor: pointer;

                    &:hover {
                      text-decoration: none;
                    }
                  }
                }
                .add-button {
                  grid-area: add-button;
                  text-align: right;

                  @include breakpoint-1024() {
                    button.button-personalize-small {
                      width: 100%;
                      margin: 10px 0;
                    }
                  }
                }
            }
        }
    }

</style>
